<template>
  <div class="pop_up_bg">
    <div class="addWechat_content">
      <div class="header">
        <span class="title">{{ firstTitle }}</span>
        <i class="iconfont icon-guanbi" @click="close" />
      </div>
      <div class="iframe_box" v-loading="!authURL">
        <iframe :src="authURL" frameborder="0" width="1200px" height="100%"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { getAuthURLApi } from '@/api/setUser';
import { mapGetters } from 'vuex';
// import previewConfig from '@/config/preview.js';
// import QRCode from 'qrcodejs2';
// import config from '@/config';
export default {
  name: 'AddWechat',
  props: {
    firstTitle: {
      type: String,
      default: '添加公众号',
    },
  },
  data() {
    return {
      authURL: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      enterpriseId: 'getEnterpriseId',
    }),
  },
  created() {
    this.getAuthURL();
    window.confirm = () => {
      this.close();
    };
  },
  methods: {
    close() {
      this.$emit('hideDialog');
    },
    getAuthURL() {
      getAuthURLApi({
        enterprise_id: String(this.enterpriseId),
      }).then((res) => {
        this.authURL = `https://open.tsepcn.com/redirectToWechat.html?url=${encodeURIComponent(
          res.authURL,
        )}`;
        console.log(this.authURL);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// @import './index.scss';
.pop_up_bg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  .addWechat_content {
    padding: 20px;
    background: #fff;
    height: 80vh;
    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .title {
        font-size: 16px;
        color: #303133;
      }

      .iconfont {
        font-size: 24px;
        cursor: pointer;
        color: #666;
      }
    }
    .iframe_box {
      height: calc(100% - 40px);
      width: 1200px;
    }
  }
}
</style>
